import { useTranslation } from 'react-i18next'
import { PageLayout } from './PageLayout'
import { PageHeader } from './PageHeader'

/**
 * Landing fallback for users who may not open any of the landing targets. Rendered inside the
 * layout on purpose — sidebar and header stay usable so the user can navigate somewhere they
 * do have access to.
 */
export function NoAccessNotice() {
  const { t } = useTranslation('common')

  return (
    <PageLayout>
      <PageHeader title={t('noAccess.title')} description={t('noAccess.description')} />
    </PageLayout>
  )
}
